import { datadogLogs } from "@datadog/browser-logs";

const setDatadogStreamId = (streamId?: string) => {
  if (streamId) {
    datadogLogs.setGlobalContextProperty("stream", streamId);
  } else {
    datadogLogs.removeGlobalContextProperty("stream");
  }
};

export { setDatadogStreamId };
